import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { ProfileUpdateResponse } from '../models/profile-vehicle.model';
import {
  PaperlessEnrollmentPutRequest,
  PaperlessEnrollmentPutResponse,
  ProfileEmailGetRequest,
  ProfileEmailUpdateRequest,
  ProfileResidenceResponse,
  ProfileResidenceUpdateRequest,
} from '../models/profile-residence.model';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { updateProfileEmailSuccess } from '../store/actions/profile.actions';
import { Store } from '@ngrx/store';
import { ProfilePaperless } from '../models/profile-paperless.model';
import { getNormalizedPaperlessProfiles } from '../util/profile.util';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly baseUrl: string;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly cookieService: CookieService,
    private readonly store: Store
  ) {}

  getResidenceInfo() {
    return this.httpClient.get<ProfileResidenceResponse[]>(`${environment.cswCustomerService}/profile/residence`, {
      headers: new HttpHeaders().set('Authorization', this.cookieService.get('X-Access-Token')),
    });
  }

  updateProfileResidence(request: ProfileResidenceUpdateRequest) {
    return this.httpClient.put<ProfileUpdateResponse>(`${environment.cswCustomerService}/profile/residence`, request, {
      headers: new HttpHeaders().set('Authorization', this.cookieService.get('X-Access-Token')),
    });
  }

  getProfileEmail(request: ProfileEmailGetRequest) {
    return this.httpClient.get(`${environment.cswCustomerService}/${request.customerId}/profile/email`, {
      headers: new HttpHeaders().set('Authorization', this.cookieService.get('X-Access-Token')),
    });
  }

  updateProfileEmail(request: ProfileEmailUpdateRequest) {
    return this.httpClient
      .put<any>(`${environment.cswCustomerService}/${request.customerId}/profile/email`, request.reqBody, {
        headers: new HttpHeaders().set('Authorization', this.cookieService.get('X-Access-Token')),
      })
      .pipe(tap(() => this.store.dispatch(updateProfileEmailSuccess({ response: request }))));
  }

  getProfilePaperless(customerId: number) {
    return this.httpClient
      .get<ProfilePaperless[]>(`${environment.cswCustomerService}/${customerId}/profile/loanCustomFields`, {
        headers: new HttpHeaders().set('Authorization', this.cookieService.get('X-Access-Token')),
      })
      .pipe(
        timeout(30000), // Set timeout to 30 seconds
        map((res) => getNormalizedPaperlessProfiles(res)),
        catchError((error) => {
          if (error.name === 'TimeoutError') {
            // Handle timeout error
            console.error('Request timed out');
            return throwError('The request took too long and timed out.');
          }
          // Handle other errors
          return throwError(error);
        })
      );
  }

  updatePaperlessEnrollmentStatus(request: PaperlessEnrollmentPutRequest) {
    return this.httpClient
      .put<PaperlessEnrollmentPutResponse>(
        `${environment.cswCustomerService}/${request.customerId}/profile/paperless/enroll`,
        request.reqBody,
        {
          headers: new HttpHeaders().set('Authorization', this.cookieService.get('X-Access-Token')),
        }
      )
      .pipe(
        map((res) => {
          if (res.status === 'failure') {
            throw throwError(() => new Error('Not enrolled error.'));
          }
          return res;
        })
      );
  }
}
